import { render, staticRenderFns } from "./MyCashAdvancesDetails.vue?vue&type=template&id=0af22fa2"
import script from "./MyCashAdvancesDetails.vue?vue&type=script&lang=js"
export * from "./MyCashAdvancesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports